(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Move every size-chart modal to the end of <body>
    // This escapes any parent stacking context (sticky header problem)
    document.querySelectorAll('[data-size-chart-modal]').forEach((modal) => {
      document.body.appendChild(modal);
    });

    const triggers = document.querySelectorAll('[data-size-chart-open]');
    const modals = document.querySelectorAll('[data-size-chart-modal]');

    triggers.forEach((trigger, index) => {
      const modal = modals[index];
      if (!modal) return;

      const openModal = () => {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      };

      trigger.addEventListener('click', openModal);

      modal.querySelectorAll('[data-size-chart-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
